import { createFileRoute } from "@tanstack/react-router";
import { ManagePromptTemplatesRoute } from "src/containers/managePromptTemplatesRoute";

export const Route = createFileRoute("/_layout-nosidebar/managePromptTemplates")({
    component: ManagePromptTemplatesPage,
});

export default function ManagePromptTemplatesPage() {
    return <ManagePromptTemplatesRoute />;
}
